module.exports = __webpack_public_path__ + "img/vmp_ch_isabella_0.cdcc00ef.png";